import { SelectItem } from "@/components/ui/select";
import { type SelectOptions } from ".";

export const SelectItems = ({ options }: { options: SelectOptions }) => {
  return options.map((option) => (
    <SelectItem key={option.value} value={option.value} label={option.label}>
      {option.label}
    </SelectItem>
  ));
};
